// extracted by mini-css-extract-plugin
export default {"withHandle":"Drawer_withHandle__Vrke5"};